import { EUROCARAVAN_SORT_ORDER } from '../../../Constants';
import { sortAlphabetically, sortByPropWithOrder } from '../../../utils/utils';

export const getRegionById = (regions, regionId) => {
  return regions[regionId];
};

export const getRegionsByChannelId = (regions, channelRegionIds, channelId) => {
  return channelRegionIds[channelId]?.map((regionId) => regions[regionId]);
};

export const getOperatorRegionsById = (regions, operatorChannelRegionIds, channelId, operatorId) => {
  return operatorChannelRegionIds[operatorId]?.[channelId]?.map((regionId) => regions[regionId]);
};

export const filtersAndSortedResults = (results, channelId) => {
  if (!Array.isArray(results)) return [];

  // Lose Ireland and Central England
  const excludedIds = ['15', '21'];
  const filteredResults = results.filter((region) => !excludedIds.includes(region.id));
  
  if (channelId === 'eurocaravan') {
    sortByPropWithOrder(filteredResults, EUROCARAVAN_SORT_ORDER, 'name');
  } else {
    filteredResults.sort(sortAlphabetically);
  }

  return filteredResults;
};
